import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import drivingApi from 'api/drivingApi';
import { selectElearningUser } from 'store/elearning.slice';
import { PATH } from 'constants/path';

// Component "vô hình" gắn trong StudentElearningLayout: sau khi student
// load xong, kiểm tra `course.requireInfoConfirmation`. Nếu HV chưa xác
// nhận + chưa có pending request → redirect tới page xác nhận. Khi xong
// (page tự navigate về root), `confirmedAt` đã set → không redirect lại.
//
// Gate 2 lớp tránh 401 race + lãng phí call khi feature tắt:
//   1) Đợi `student._id` (sessionToken đã lưu)
//   2) Chỉ gọi /info-confirmation/me khi course.requireInfoConfirmation
//      = true
function InfoConfirmationRedirect() {
  const student = useSelector(selectElearningUser);
  const navigate = useNavigate();
  const location = useLocation();
  // Tránh gọi API lặp lại khi student object re-render mà id không đổi.
  const checkedForRef = useRef(null);

  useEffect(() => {
    if (!student?._id) return;
    if (!student?.course?.requireInfoConfirmation) return;
    // Đang ở chính page xác nhận → không cần redirect, page tự xử lý.
    if (location.pathname === PATH.ELEARNING.STUDENT.INFO_CONFIRMATION) return;
    // Đã check cho student này rồi → bỏ qua.
    if (checkedForRef.current === student._id) return;
    checkedForRef.current = student._id;

    drivingApi
      .getMyInfoConfirmation()
      .then((res) => {
        const data = res?.data || {};
        const needsConfirmation = data.requireConfirmation && !data.confirmedAt && !data.pendingRequest;
        if (needsConfirmation) {
          navigate(PATH.ELEARNING.STUDENT.INFO_CONFIRMATION, { replace: true });
        }
      })
      .catch(() => {
        // Best-effort: nếu fail, không chặn flow học — log ngầm.
      });
  }, [student?._id, student?.course?.requireInfoConfirmation, location.pathname, navigate]);

  return null;
}

export default InfoConfirmationRedirect;
